import React from 'react';
import { Modal as BaseModal } from 'baseui/modal';
import { useModal } from './ModalProvider';

const Modal = () => {
  const { component, isOpen, config, closeModal } = useModal();

  return (
    <BaseModal isOpen={isOpen} onClose={closeModal} {...config}>
      {component}
    </BaseModal>
  );
};

export default Modal;
